import React from 'react';

import { Loader } from 'components';
import { assertUnreachable } from 'utils/typescript';
import {
    ChildrenContainer,
    LoadingContainer,
    OutlinedPrimaryStyledButton,
    PrimaryStyledButton,
} from './Button.style';

export type ButtonType = 'primary' | 'secondary';

export type ButtonProps = {
    buttonType?: ButtonType;
    thick?: boolean;
    fullWidth?: boolean;
    disabled?: boolean;
    hasBorder?: boolean;
    isLoading?: boolean;
    isSubmit?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const Button: React.FunctionComponent<
    ButtonProps & Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>
> = ({
    children,
    buttonType = 'primary',
    hasBorder = true,
    isLoading = false,
    disabled = false,
    isSubmit = false,
    ...otherProps
}) => {
    const getButton = () => {
        switch (buttonType) {
            case 'primary':
                return PrimaryStyledButton;
            case 'secondary':
                return OutlinedPrimaryStyledButton;
            default:
                return assertUnreachable(buttonType);
        }
    };

    const ButtonComponent = getButton();

    return (
        <ButtonComponent
            data-testid="button"
            {...otherProps}
            disabled={disabled}
            hasBorder={hasBorder}
            type={isSubmit ? 'submit' : 'button'}
        >
            <ChildrenContainer isLoading={isLoading}>{children}</ChildrenContainer>
            {isLoading && (
                <LoadingContainer>
                    <Loader size={16} />
                </LoadingContainer>
            )}
        </ButtonComponent>
    );
};
